import React from 'react';
import { Link } from 'react-router-dom';
import { PlayButton } from '../../components/play-button';
import './index.less';

interface IUpNextProps {
	cover?: string;
	countdown?: number;
	nextVideoId: string;
	browseId?: string;
	playlistId?: string;
	playerId?: string;
	title?: string;
}

interface IUpNextState {
	interactive: boolean;
}

export class UpNext extends React.Component<IUpNextProps, IUpNextState> {
	state: IUpNextState = {
		interactive: true,
	};

	componentWillMount() {
		const player = this.props.playerId ? window.videojs(this.props.playerId) : null;
		const interactive = !(player && player.isFullscreen());
		this.setState({ interactive });
	}

	render() {
		const { cover, countdown, nextVideoId, browseId, playlistId, title } = this.props;
		const { interactive } = this.state;
		const browseLink = browseId ? `/items/${browseId}` : '/';

		return (
			<div className="up-next container">
				<div className="preview">
					<h3>Next video will play in {countdown} seconds</h3>
					{title ? <h2>{title}</h2> : false}
					<div className="cover">
						{/* TODO: Fix this the next time the file is edited. */}
						{/* eslint-disable-next-line jsx-a11y/alt-text */}
						<img className="cover-image" src={cover} />
						{interactive ? <PlayButton itemId={nextVideoId} playlistId={playlistId} /> : null}
					</div>
					{interactive ? (
						<Link to={browseLink}>
							<button>Back to browse</button>
						</Link>
					) : null}
				</div>
			</div>
		);
	}
}
